import { z } from "zod";

export const tenantConfigSchema = z.object({
  tenantId: z.string(),
  labels: z.record(z.string(), z.string()).default({}),
  theme: z
    .object({
      primary: z.string().optional(),
      radius: z.string().optional(),
    })
    .default({}),
  features: z.record(z.string(), z.boolean()).default({}),
});

export type TenantConfig = z.infer<typeof tenantConfigSchema>;

export const defaultTenantConfig = (tenantId: string): TenantConfig => ({
  tenantId,
  labels: {},
  theme: {},
  features: {},
});
